import {useEffect, useState} from "react";
import {RadioButton, Table} from "@wfp/ui";
import {useTranslation} from "react-i18next";
import {KVPair, ListPage, SnackCategory, Sortable} from "../../models/types";
import {TablePagination} from "../commons/table-pagination/table-pagination";

interface Props {
    hidePagination?: boolean;
    page: ListPage<SnackCategory>;
    loadPage: (page: number, pageSize?: number, filtering?: KVPair[], sorting?: string[]) => void;
    onClick?: (id: number) => void;
    sort?: (field: string) => void;
    onSelect?: (id: number) => void;
    sortInfo?: Sortable[];
    selectId?: number;
}

const headerCategory = ["id", "name"];

export function SnackCategoryTable(props: Props) {
    const {t} = useTranslation();
    const [sortables, setSortables] = useState<Sortable[]>();
    const [radioChecked, setRadioChecked] = useState<boolean[]>();


    useEffect(() => {
        if(!!props.page) {
            const checked = props.page.results?.map((s) => !!props.selectId ? s.id === props.selectId : false);
            setRadioChecked(checked);
        }

    },[props.page, props.selectId]);


    useEffect(() => {
        if (!!props.sortInfo) {
            const sorts = headerCategory.map((headerCategory) => {
                const sort = props.sortInfo?.find((sort) => sort.code === headerCategory);
                return !!sort ? sort : {code: headerCategory, field: headerCategory, mode: 0, enabled: false}
            });
            setSortables(sorts);
        }
    }, [props.sortInfo]);


    function handleSorting(idx: number) {
        if (!!sortables && !!props.sort) {
            const sortable = sortables[idx];
            if (!sortable.enabled) {
                return;
            }
            sortable.mode = (sortable.mode + 1) % 3;
            setSortables([...sortables]);
            const value = sortable.mode === 1 ? `+${sortable.field}` : sortable.mode === 2 ? `-${sortable.field}` : sortable.field;
            props.sort(value);
        }
    }

    return (
        <div className='min-h-800 relative'>
            <Table>
                <thead>
                <tr className="item-row-head">
                    {!!props.onSelect && (
                        <th></th>
                    )}
                    {headerCategory.map((header, idx) => (
                        <th key={idx} onClick={() => handleSorting(idx)}
                            className={props.sort && sortables?.at(idx)?.enabled ? "cursor-pointer" : ""}>
                            {t(header)}
                            {!!sortables?.length && (
                                <span className="ml-0.5">
                                {sortables[idx].mode === 2 ? '\u25bc' : sortables[idx].mode === 0 ? '\u2000' : '\u25b2'}
                            </span>
                            )}
                        </th>
                    ))}
                </tr>
                </thead>
                <tbody>
                {props.page.results.map((item: SnackCategory, idx) => (
                    <tr className="item-row" key={item.id}>
                        {!!props.onSelect && (
                            <td className="item-col text-start">
                                <RadioButton labelText={''} name='row-select' value={item.id} checked={radioChecked?.at(idx) || false}
                                             onChange={() => !!props.onSelect ? props.onSelect(item.id) :  radioChecked![idx] = true}></RadioButton>
                            </td>
                        )}
                        <td className="item-col text-start">
                            {item.id}
                        </td>
                        <td className="item-col text-start">
                            {item.name}
                        </td>
                    </tr>
                ))}
                </tbody>
            </Table>
            {!props.hidePagination && (
                <TablePagination page={props.page} loadPage={props.loadPage}/>
            )}
        </div>
    )
}
